const spacingCSS = `
    .my-1 {
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
    }
    .my-2 {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    .my-3 {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
    .my-4 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }
    .my-5 {
        margin-top: 3rem;
        margin-bottom: 3rem;
    }
`;

export default spacingCSS;